"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MediaUtil = void 0;
function MediaUtil() {
    return {
        aggregate: function (media, allMedia) {
            var mediaAggregate = {
                _id: media._id,
                createdAt: media.createdAt,
                updatedAt: media.updatedAt,
                isInRoot: media.isInRoot,
                mimetype: media.mimetype,
                name: media.name,
                path: media.path,
                size: media.size,
                state: false,
                type: media.type,
                userId: media.userId,
            };
            if (media.hasChildren) {
                mediaAggregate.children = [];
                var childrenIndexes = [];
                for (var i = 0; i < allMedia.length; i = i + 1) {
                    if (allMedia[i].parentId === media._id) {
                        childrenIndexes.push(i);
                    }
                }
                for (var i in childrenIndexes) {
                    var child = allMedia[childrenIndexes[i]];
                    if (child.hasChildren) {
                        mediaAggregate.children.push(this.aggregate(child, allMedia));
                    }
                    else {
                        mediaAggregate.children.push({
                            _id: child._id,
                            createdAt: child.createdAt,
                            updatedAt: child.updatedAt,
                            isInRoot: child.isInRoot,
                            mimetype: child.mimetype,
                            name: child.name,
                            path: child.path,
                            size: child.size,
                            state: false,
                            type: child.type,
                            userId: child.userId,
                        });
                    }
                }
            }
            return mediaAggregate;
        },
        aggregateFromRoot: function (media) {
            var aggregated = [];
            for (var i in media) {
                if (media[i].isInRoot) {
                    aggregated.push(this.aggregate(media[i], media));
                }
            }
            return aggregated;
        },
    };
}
exports.MediaUtil = MediaUtil;
//# sourceMappingURL=media.js.map